import {Component, OnInit} from '@angular/core';
import {MaintenanceService, PlannedMaintenance} from "../../../core/services/maintenance.service";
import { TranslateModule } from '@ngx-translate/core';
import {HeadlineTextComponent} from "../../components/headline-text/headline-text.component";
import {NgOptimizedImage} from "@angular/common";
import {MatCard, MatCardContent} from "@angular/material/card";
import {HeadlineWithIconComponent} from "../../components/headline-with-icon/headline-with-icon.component";
import {
  HeadlineWithIconAndInfoBoxComponent
} from "../../components/headline-with-icon-and-info-box/headline-with-icon-and-info-box.component";

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    standalone: true,
  imports: [TranslateModule, HeadlineTextComponent, NgOptimizedImage, MatCardContent, MatCard, HeadlineWithIconComponent, HeadlineWithIconAndInfoBoxComponent]
})
export class ErrorComponent {
}
